import { render, staticRenderFns } from "./ChildNameStep.vue?vue&type=template&id=07d5810a"
import script from "./ChildNameStep.vue?vue&type=script&lang=js"
export * from "./ChildNameStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports